import { convertUtcToUae } from "@utils/date-time";

const UAE_WALL_CLOCK = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/;

/** The pickers work on a Date whose local fields are the UAE wall clock, whatever the browser zone is. */
export const toUaeWallClockDate = (utcIso: string): Date => {
  const [, year, month, day, hours, minutes, seconds] = UAE_WALL_CLOCK.exec(
    convertUtcToUae(utcIso),
  ) as RegExpExecArray;
  return new Date(+year, +month - 1, +day, +hours, +minutes, +seconds);
};

export const fromUaeDay = (day: string): Date => {
  const [year, month, date] = day.slice(0, 10).split("-").map(Number);
  return new Date(year, month - 1, date);
};
